import React from "react";
import './Home.css'

function Contact() {

    return(
        <>

<div className="items">
        
        <h1 style={{color:"black"}}>Contact </h1>
        <p style={{color:"black"}}>We love hearing from our customers and partners. 
        If you have any questions, feedback, or inquiries, please don't hesitate to get in touch. 
        You can reach us via ....</p>
        <h1 style={{color:"black"}}>phone Number - 9566959970.</h1> 

        <h1 style={{color:"black"}}>E-mail - fun-o-fun@gmail.com</h1>
        <p>Thank you for choosing Fun-o-Fun Vacations! We look forward to serving you
     and becoming our trusted resources.</p>
        
  
    </div>


    
        </>
    )
    
}
export default Contact